<script>
    let bodyPart = "Chd"
    let num = 40

    function random(max) {
        return 1 + Math.floor(Math.random() * Math.floor(max));
    }

    function randomizeNum() {
        num = random(70)
    }
</script>

<div class="parent">
    <span class="title">R - L</span>
    <span class="subTitle" on:click={()=>{bodyPart = "LIVER"; randomizeNum()}}>LIVER</span>
    <span class="subTitle" on:click={()=>{bodyPart = "CHD"; randomizeNum()}}>CHD</span>
    <span class="subTitle" on:click={()=>{bodyPart = "CBD"; randomizeNum()}}>CBD</span>
    <span class="subTitle" on:click={()=>{bodyPart = "GB"; randomizeNum()}}>GB Wall</span>
    <span class="subTitle" on:click={()=>{bodyPart = "Panc"; randomizeNum()}}>Panc Dust</span>
    <span class="subTitle" on:click={()=>{bodyPart = "Spleen"; randomizeNum()}}>Spleen</span>
    <span class="subTitle" on:click={()=>{bodyPart = "Kidney"; randomizeNum()}}>Kidney</span>
    <span class="subTitle" on:click={()=>{bodyPart = "PreVoid"; randomizeNum()}}>PreVoid Bld</span>
    <span class="subTitle" on:click={()=>{bodyPart = "PostVoid"; randomizeNum()}}>PostVoid Bld</span>

    <div id="picked">
        <span id="picked-item">{bodyPart.toUpperCase()}</span>
    </div>

    <span class="title">FOURIER HZ</span>
    <span class="subTitle">FFT: {num}</span>
    <span class="subTitle">DFT: {(Math.sin(num)/2).toPrecision(3)}</span>
    <div class="sunken">
        <input type="range" min="1" bind:value={num}>
    </div>

</div>


<style>
    #picked {
        justify-content: center;
        text-align: center;
        margin: 1rem 1rem;
        padding: 1rem;
        height: 5rem;
        display:flex;
        align-items: center;
        align-content: center;
        border: 5px solid white;
        filter:drop-shadow(1px 1px 20px white);
    }
    #picked-item {
        align-self: center;
        font-size: 1.5rem;
        font-weight: bolder;
        color: yellow;
        filter:drop-shadow(1px 1px 20px white);
    }
    .title, .subTitle{
        display:block;
        color:white;
        padding: 0.3rem;
        font-size: .75rem;
    }
    .title {
        font-weight: bold;
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px white;;
        background: linear-gradient(90deg, rgb(32, 57, 149) 0%, rgba(32,32,134,0) 100%);
        margin-top: 1rem;
    }
    .subTitle {
        margin-left: 1rem;
        margin-top: 0.25rem;
        padding: 0.25rem;
        cursor:pointer;
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px white;
    }
    .subTitle:hover {
        color: darkblue;
        background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgba(32,32,134,0) 100%);
        box-shadow: 5px 0 15px midnightblue inset, 0 1px 2px midnightblue;
    }
    .sunken {

    }

</style>